module.exports = __webpack_public_path__ + "static/img/main_service.d3ff649.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/pc/images/main_service.png
// module id = bGCm
// module chunks = 0